import React, { useContext, useState, useEffect } from "react";

import { NavLink as Link, useNavigate } from "react-router-dom";
import {
  authRequest,
  authRequestNb,
  sendGetRequest,
  fixedNumber,
  refreshToken,
} from "../../../Helper/helper";


const Cryptotabs = () => {
  const [data, setData] = useState();
  const getAutoData = async () => {
    const res = await sendGetRequest("top-gainer");
    //console.log("res=>",res.data.gtoken);//
    refreshToken(res.refresh_token);
    setData(res.data);
  };
  useEffect(() => {
    (async () => {
      getAutoData();
    })();
  },[])

  return (
    <div className="table-responsive table-fluid">
  <table className="table latestdesigntable w-25-per">
    <thead>
      <tr>
        <th>Name</th>
        <th>Price(INR)</th>
        <th>Change</th>
        {/* <th>Last 24H</th> */}
        <th>Volume(INR)</th>
      </tr>
    </thead>
    <tbody>
      {
        (data)?
        (
          data &&
          data.length > 0 &&
          data?.map((coin, i) => (
            //var newdata=coin.chartData;
            <>
              <tr className="">
                <td><a href='/exchange'><img src={coin?.icon} className="img-fluid icon" /> <b>{coin?.currency_symbol.toUpperCase()}</b> {/*  <span>TCC</span> */}</a></td>
                <td>{coin?.price}</td>
                <td><span className="greentext">{parseFloat(coin?.percent_change).toFixed(2)}%</span></td>
                {/* <td>
                  <svg data-v-bb4783ea="" width="90" height="40" viewBox="0 0 90 40" strokeWidth="2" className="trend"><defs><linearGradient id="vue-trend-912" x1="0" y1="1" x2="0" y2="0"><stop offset="0" stopColor="#44BD22"></stop></linearGradient></defs><path d={`M8 ${coin?.Chdata.toString().replaceAll(","," ")}`} fill="none" stroke="url(#vue-trend-912)"></path></svg>
                </td> */}
                <td>{coin?.quote}</td>
              </tr>
            </>
          ))
        )
        :
        <>
         <tr className="">
          <td  colspan="5">

                  Loading...
          </td>
         </tr>
        </>
      }
    
      
     {/*  
        <tr className="">
            <td><a href='/exchange'><img src="https://btrlexchange.com/backend/assets/images/currency-logo/tcc.png" className="img-fluid icon" /> <b>The Champcoin Coin</b> <span>TCC</span></a></td>
            <td>26,599,555</td>
            <td><span className="greentext">+0.78%</span></td>
            <td>
              <svg data-v-bb4783ea="" width="90" height="40" viewBox="0 0 90 40" strokeWidth="2" className="trend"><defs><linearGradient id="vue-trend-912" x1="0" y1="1" x2="0" y2="0"><stop offset="0" stopColor="#44BD22"></stop></linearGradient></defs><path d="M8 14.34951895700257L11.363636363636363 8.0000340820981S11.363636363636363 8.0000340820981 11.363636363636363 8.0000340820981L14.727272727272727 12.201334314140396S14.727272727272727 12.201334314140396 14.727272727272727 12.201334314140396L18.090909090909093 12.118514815772066L21.454545454545453 11.812798395869219S21.454545454545453 11.812798395869219 21.454545454545453 11.812798395869219L24.81818181818182 12.60282142968719S24.81818181818182 12.60282142968719 24.81818181818182 12.60282142968719L28.181818181818183 29.158541399808477S28.181818181818183 29.158541399808477 28.181818181818183 29.158541399808477L31.545454545454547 30.87968735355339S31.545454545454547 30.87968735355339 31.545454545454547 30.87968735355339L34.90909090909091 27.30788347330655S34.90909090909091 27.30788347330655 34.90909090909091 27.30788347330655L38.27272727272727 28.9727939651965S38.27272727272727 28.9727939651965 38.27272727272727 28.9727939651965L41.63636363636364 26.47832520569959S41.63636363636364 26.47832520569959 41.63636363636364 26.47832520569959L45 25.353956789579968S45 25.353956789579968 45 25.353956789579968L48.36363636363637 28.93053216355994L51.72727272727273 31.9999659179019S51.72727272727273 31.9999659179019 51.72727272727273 31.9999659179019L55.09090909090909 31.220508334492976S55.09090909090909 31.220508334492976 55.09090909090909 31.220508334492976L58.45454545454545 27.076466027248543S58.45454545454545 27.076466027248543 58.45454545454545 27.076466027248543L61.81818181818182 27.181438889377993S61.81818181818182 27.181438889377993 61.81818181818182 27.181438889377993L65.18181818181819 25.770780849269066S65.18181818181819 25.770780849269066 65.18181818181819 25.770780849269066L68.54545454545455 27.932608331368872S68.54545454545455 27.932608331368872 68.54545454545455 27.932608331368872L71.9090909090909 26.794266255030603S71.9090909090909 26.794266255030603 71.9090909090909 26.794266255030603L75.27272727272728 26.20260103211946S75.27272727272728 26.20260103211946 75.27272727272728 26.20260103211946L78.63636363636364 18.720898858533648L82 11.175132340531281" fill="none" stroke="url(#vue-trend-912)"></path></svg>
            </td>
            <td>26,599,555</td>
          </tr>
          
          <tr className="">
            <td><a href='/exchange'><img src="https://btrlexchange.com/backend/assets/images/currency-logo/tcc.png" className="img-fluid icon" /> <b>The Champcoin Coin</b> <span>TCC</span></a></td>
            <td>26,599,555</td>
            <td><span className="redtext">-0.78%</span></td>
            <td></td>
            <td>26,599,555</td>
          </tr> 
      */}
    </tbody>
  </table>
  </div>
  );
};

export default Cryptotabs;
